import React from "react";
import WeekSelector from "./WeekSelector";
import DropdownSelector from "./DropdownSelector";
import NewsScroll from "./NewsScroll";
import SubscriptionRequest from "./SubscriptionRequest";
import UploadPdfModal from "./UploadPdfModal";

function UserScreen({
                        selectedYear,
                        selectedWeek,
                        handleChangeWeek,
                        entityRef,
                        selectedEntities,
                        handleChangeEntities,
                        entityRefLoading,

                        setShowAdmin,

                        toggleUploadPdf,
                        toggleSubscriptionForm,
                        toggleNewsletterQnA,

                        showSubscriptionForm,
                        showUploadPdf,

                        isAdmin,
                        adminToken,
                        apiRootUrl,
                        data,

                        instance,
                        accounts,
                        loginRequest
                    }) {
    return (
        <div className="user-screen">
            <div className="selection-row">

                <div className="selection-column">
                    <WeekSelector
                        week={`${selectedYear}-${selectedWeek < 10 ? '0' + selectedWeek : selectedWeek}`}
                        handleChangeWeek={handleChangeWeek}
                    />

                    <div className="dropdown-wrapper">
                        <DropdownSelector
                            entityRef={entityRef}
                            selectedEntities={selectedEntities}
                            handleChangeEntities={handleChangeEntities}
                            selectedYear={selectedYear}
                            selectedWeek={selectedWeek}
                            disabled={entityRefLoading}
                        />
                    </div>
                </div>

                <div className="selection-column right">

                    <div className="nav-links">
                        <button className="nav-link" onClick={() => setShowAdmin(true)}>
                            Administration
                        </button>

                        <button className="nav-link" onClick={toggleUploadPdf}>
                            Process Alphaliner PDF
                        </button>

                        <button className="nav-link" onClick={toggleSubscriptionForm}>
                            Request Subscription
                        </button>

                        <button className="nav-link" onClick={toggleNewsletterQnA}>
                            Newsletter Q&amp;A
                        </button>
                    </div>

                    {showSubscriptionForm && (
                        <SubscriptionRequest
                            onClose={toggleSubscriptionForm}
                            instance={instance}
                            accounts={accounts}
                            loginRequest={loginRequest}
                        />
                    )}

                    <UploadPdfModal
                        isAdmin={isAdmin}
                        adminToken={adminToken}
                        open={showUploadPdf}
                        onClose={toggleUploadPdf}
                        apiRootUrl={apiRootUrl}
                        defaultYear={selectedYear}
                        defaultWeek={selectedWeek}
                    />
                </div>
            </div>

            <div>
                <br /><p><i>News summarization is provided by a test AI application. Please report inaccuracies or anomalies to <a href="mailto:itsupport@capps.com">itsupport@capps.com.</a></i></p>
                {data.map((document, i) => (
                    <NewsScroll
                        key={i}
                        entityRef={entityRef}
                        document={document}
                        instance={instance}
                        loginRequest={loginRequest}
                    />
                ))}
            </div>
        </div>
    );
}

export default React.memo(UserScreen);